module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("kAUcS"))).then(() => parcelRequire('hEqeo'));